export default {
    logged(state) { //(satte,getters)
        if ('token' in state.login && state.login.token) { return true; }
        return false;
    },
    namespace: (state) => (componentNamespace, property) => {
        if (! componentNamespace) {
            return;
        }

        let data = {};
        if (Object.keys(state.namespace).length !== 0) {
            eval(`data = state.namespace.${componentNamespace}.${property}`);
        }

        return data;
    }
}